function openMenuHandler() {
  const menuBtn = document.querySelector(".main-nav__toggle");
  const menu = document.querySelector(".header-menu");
  menuBtn.addEventListener("click", () => {
    menu.classList.toggle("header-menu--open");
  });
}

export { openMenuHandler };
